var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngagementrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.882,
    height: 12.94,
    viewBox: "0 0 13.882 12.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.584,309.267a.339.339,0,0,0-.27-.108.358.358,0,0,0-.278.109.417.417,0,0,0-.1.286.43.43,0,0,0,.1.292.358.358,0,0,0,.278.1.334.334,0,0,0,.27-.1l0,0a.409.409,0,0,0,.1-.291.391.391,0,0,0-.1-.285Z",
    transform: "translate(-279.175 -301.268)",
    fill: "#c6c9d8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.941,17.426,0,25.091H2.958v5.274h7.966V25.091h2.958Zm-2.277,5.95a1.028,1.028,0,0,1,.311-.762,1.089,1.089,0,0,1,1.536,0,1.028,1.028,0,0,1,.311.762,1.086,1.086,0,0,1-1.847.768A1.048,1.048,0,0,1,4.664,23.376Zm.35,3.192,3.335-4.451.508.4L5.52,26.973Zm3.893-.087a1.079,1.079,0,0,1-1.847-.768,1.028,1.028,0,0,1,.311-.762,1.09,1.09,0,0,1,1.536,0,1.028,1.028,0,0,1,.311.762A1.048,1.048,0,0,1,8.907,26.48Z",
    transform: "translate(0 -17.426)",
    fill: "#c6c9d8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.022,223.47l0,0a.409.409,0,0,0,.1-.291.39.39,0,0,0-.1-.285l0,0a.338.338,0,0,0-.27-.108.358.358,0,0,0-.278.109.416.416,0,0,0-.1.286.43.43,0,0,0,.1.292.358.358,0,0,0,.278.1A.335.335,0,0,0,199.022,223.47Z",
    transform: "translate(-193.009 -217.226)",
    fill: "#c6c9d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementrate);
export default __webpack_public_path__ + "static/media/engagementrate.8a7411ebb71cabf78d8adc15b771fd46.svg";
export { ForwardRef as ReactComponent };